import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { environment } from '@app/env-service';
import { UnitConversionRuleInterface } from '@app/modules/unit-measurement/interfaces/unit-measurement.interface';

@Injectable({
  providedIn: 'root',
})
export class RfqConversionRulesService {
  url :string = environment.url;
  urlV2 :string = environment.urlV2;

  private readonly _rfqConversionRules = new BehaviorSubject<
    UnitConversionRuleInterface[]
  >(<UnitConversionRuleInterface[]>[]);
  public rfqConversionRules$ = this._rfqConversionRules.asObservable();

  public gettingRecords :boolean = false;

  private params :any = {
    limit: 20,
    page: 1,
  };

  constructor(private http :HttpClient) {}

  getRfqConversionRules(params) :Subscription {
    this.gettingRecords = true;

    return this.http
      .get(`${this.urlV2}/uom/unit-conversion-rules/rfq-and-system`, {
        params: params,
      })
      .subscribe((resp :any) => {
        this._rfqConversionRules.next(resp);
        this.gettingRecords = false;
      });
  }

  refreshList() :void {
    this.getRfqConversionRules(this.params);
  }

  setParams(params :any) :void {
    this.params = params;
  }
}
